import _ from 'lodash';

import {
  BANK_ACCOUNT_UID, CHARGING_BANK_FEE_UID,
  CLEARING_ACCOUNT_BALANCING_QUESTION_UID,
  CLEARING_ACCOUNT_OPTION_QUESTION_UID,
  CLEARING_ACCOUNT_QUESTION_UID,
  FIELD_DOES_NOT_FITT_MSG,
  NOTES_FOR_ORIGIN_OF_ASSETS_UID, ORIGIN_OF_ASSETS_NEW_UID,
  ORIGIN_OF_ASSETS_UID, QUESTION_TYPE,
  REF_ACCOUNT_STEP_ID
} from "../../constants";
import {validateMultilineContent} from "../../utils";
import AssetsOriginStep from "../StepContent/components/step/CustomerDataSteps/AssetsOriginStep";
import ReferenceAccountStep from "../StepContent/components/step/CustomerDataSteps/ReferenceAccountStep";

const BANK_FEE_OPTIONS_NAMES = {
  'bank_account': 'Referenzkonto',
  'clearing_account': 'Verrechnungskonto',
  'sale_via_quantities': 'Verkauf über Anteile',
};

export const buildDataSteps = (chargingBankFeeOptions, originOfAssetsOptions) => {
  const steps = [{
    "uid": REF_ACCOUNT_STEP_ID,
    "name": "Bitte wählen Sie ein Referenzkonto aus",
    "category": "Referenzkonto",
    "behaviour": ["dynamic"],
    "skippable": true,
    "step_content": ReferenceAccountStep,
    "question": [
      {
        "question_text": "Verrechnungskonto auswählen:",
        "uid": CLEARING_ACCOUNT_QUESTION_UID,
        "custom_classes": {"labelRoot": "bold"},
        "optional": true,
        "question": [] // list of checkbox questions. Should be filled with questions in data service, as it depends on selected portfolios and related clearing accounts
      },
      {
        "uid": CLEARING_ACCOUNT_OPTION_QUESTION_UID,
        "optional": true,
        "question": [] // list of SELECT questions. Should be filled with questions in data service, as it depends on selected portfolios and related clearing accounts
      },
      {
        "uid": CLEARING_ACCOUNT_BALANCING_QUESTION_UID,
        "optional": true,
        "question": [] // list of checkbox questions. Should be filled with questions in data service, as it depends on selected portfolios and related clearing accounts
      },
      {
        "uid": BANK_ACCOUNT_UID,
        "type": QUESTION_TYPE.REFERENCE_ACCOUNTS_V2,
        "question_text": "Gespeichertes Referenzkonto auswählen:",
        "bank_accounts": [],
        "optional": false
      }
    ]
  }];

  if(_.isArray(chargingBankFeeOptions) && chargingBankFeeOptions.length > 1){
    steps.push({
      "uid": "charging_bank_fees_step",
      "name": "Auswahl der Belastung für Bankentgelte *",
      "category": "Bankentgelte",
      "behaviour": ["dynamic"],
      "skippable": true,
      "question": [
        {
          "uid": CHARGING_BANK_FEE_UID,
          "type": "normal",
          "behaviour": [QUESTION_TYPE.RADIO_CARDS],
          "optional": false,
          "size": 6,
          "config": {
            "choices": chargingBankFeeOptions.map(option => ({
              id: option,
              uid: option,
              text: BANK_FEE_OPTIONS_NAMES[option] || _.upperFirst(option).replace('_', ' ')
            }))
          }
        }
      ]
    });
  }

  if(!_.isEmpty(originOfAssetsOptions)) {
    steps.push({
      "uid": ORIGIN_OF_ASSETS_UID,
      "name": "Herkunft der Vermögenswerte *",
      "category": "Herkunft der Vermögenswerte",
      "behaviour": ["dynamic"],
      "skippable": true,
      "step_content": AssetsOriginStep,
      "question": [
        {
          "uid": ORIGIN_OF_ASSETS_NEW_UID,
          "question_info": "Bitte beachten Sie, dass die Depotstelle gegebenfalls Belege zur Herkunft des Vermögens einfordern.",
          "type": QUESTION_TYPE.CHECKBOX_LIST_CARDS,
          "optionSize": 4,
          "optional": true,
          "required_check": true,
          "config": {
            "store_choices": true,
            "choices": originOfAssetsOptions.map(option => ({
              "id": option.id,
              "uid": option.id,
              "text": option.label,
            }))
          }
        },
        {
          "uid": NOTES_FOR_ORIGIN_OF_ASSETS_UID,
          "question_text": "Anmerkungen zur Herkunft der Vermögenswerte",
          "question_info": "Sofern insbesondere risikobasiert eine Erklärung und/oder Erläuterung zur Herkunft der Vermögenswerte erfolgen soll, tragen Sie diese oder sonstige Anmerkungen bitte hier ein.",
          "type": "input",
          "config": {
            "multiline": true
          },
          "validateImmediately": true,
          "isValid": function () {

            let isValid = true;
            this.error = null;

            if (this.answer) {
              isValid = validateMultilineContent(this.answer, 100);
              this.error = isValid ? null : FIELD_DOES_NOT_FITT_MSG
            }

            return isValid
          }
        }
      ]
    });
  }

  return {
    steps: steps
  }
};